/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Auth Pharmacist Users API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PasswordRestDto } from '../models';
/**
 * PharmacistUserProfileEndpointsApi - axios parameter creator
 * @export
 */
export const PharmacistUserProfileEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint can only be used by the pharmacist user itself, therefore it is secured via its identity token in the Authorization header.
         * @summary REST.API.AUTH.PHUSER.01 Change password of the pharmacist user.
         * @param {PasswordRestDto} body 
         * @param {string} pharmacist_user_id Uniquely identifies a pharmacist user.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePharmacistUserPassword: async (body: PasswordRestDto, pharmacist_user_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePharmacistUserPassword.');
            }
            // verify required parameter 'pharmacist_user_id' is not null or undefined
            if (pharmacist_user_id === null || pharmacist_user_id === undefined) {
                throw new RequiredError('pharmacist_user_id','Required parameter pharmacist_user_id was null or undefined when calling updatePharmacistUserPassword.');
            }
            const localVarPath = `/profile/v1/pharmacist_user/{pharmacist_user_id}/profile/password`
                .replace(`{${"pharmacist_user_id"}}`, encodeURIComponent(String(pharmacist_user_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PharmacistUserProfileEndpointsApi - functional programming interface
 * @export
 */
export const PharmacistUserProfileEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This endpoint can only be used by the pharmacist user itself, therefore it is secured via its identity token in the Authorization header.
         * @summary REST.API.AUTH.PHUSER.01 Change password of the pharmacist user.
         * @param {PasswordRestDto} body 
         * @param {string} pharmacist_user_id Uniquely identifies a pharmacist user.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePharmacistUserPassword(_axios: AxiosInstance, body: PasswordRestDto, pharmacist_user_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PharmacistUserProfileEndpointsApiAxiosParamCreator(configuration).updatePharmacistUserPassword(body, pharmacist_user_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PharmacistUserProfileEndpointsApi - object-oriented interface
 * @export
 * @class PharmacistUserProfileEndpointsApi
 * @extends {BaseAPI}
 */
export class PharmacistUserProfileEndpointsApi extends BaseAPI {
    /**
     * This endpoint can only be used by the pharmacist user itself, therefore it is secured via its identity token in the Authorization header.
     * @summary REST.API.AUTH.PHUSER.01 Change password of the pharmacist user.
     * @param {PasswordRestDto} body 
     * @param {string} pharmacist_user_id Uniquely identifies a pharmacist user.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PharmacistUserProfileEndpointsApi
     */
     public updatePharmacistUserPassword(body: PasswordRestDto, pharmacist_user_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PharmacistUserProfileEndpointsApiFp(this.configuration).updatePharmacistUserPassword(this.axios, body, pharmacist_user_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
